module.exports = __webpack_public_path__ + "img/cpt-balu.9f6ca049.jpeg";